// Shared phone styles (docs/design/SPEC.md, «Общие элементы и классы»).

// A card on a phone; from sm the block keeps its desktop look (set by the caller).
export const CARD = 'rounded-3xl bg-slate-900 p-5 sm:rounded-none sm:bg-transparent';

// A card that stays a framed block on desktop too, as the payout calendar («Рынки», docs/quotes/SPEC.md).
export const PANEL = 'rounded-3xl bg-slate-900 p-5 sm:rounded-lg sm:border sm:border-slate-700 sm:bg-slate-900/40';

// Chip: 36 px high, the touch zone grows to 44 px.
const CHIP = 'relative h-9 shrink-0 rounded-full px-3.5 text-[0.875rem] font-medium before:absolute before:inset-x-0 before:-inset-y-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400';

export function chipClass(selected) {
  return selected ? `${CHIP} bg-slate-100 text-slate-950` : `${CHIP} bg-slate-800 text-slate-300`;
}

// A row of chips that scrolls sideways inside a p-5 card.
export const CHIP_ROW = '-mx-5 flex gap-2 overflow-x-auto px-5 py-1 [scrollbar-width:none]';
